import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import dict from '@/mixins/component-dict';
export default {
  name: 'd2-dict-select',
  mixins: [dict],
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var component = h("el-select", {
      "attrs": _objectSpread(_objectSpread({}, this.attrs), {}, {
        "multiple": this.multiple
      }),
      "on": {
        "change": this.onChange
      },
      "model": {
        value: _this.currentValue,
        callback: function callback($$v) {
          _this.currentValue = $$v;
        }
      }
    }, [this.options.map(function (item) {
      return h("el-option", {
        "attrs": {
          "label": item.label,
          "value": item.value
        }
      });
    })]);
    return component;
  }
};